/**
 * Client-side connectivity failures (offline, timeout, DNS, etc.).
 * These are expected user/environment conditions — not actionable app bugs.
 */

function getMessage(err) {
  if (typeof err === 'string') return err;
  if (err instanceof Error) return err.message;
  if (typeof err?.message === 'string') return err.message;
  return '';
}

export function isNetworkErrorMessage(message) {
  if (typeof message !== 'string' || !message) return false;
  const lower = message.toLowerCase();
  return (
    lower.includes('network error') ||
    lower.includes('please check your connection') ||
    lower.includes('err_network') ||
    lower.includes('failed to fetch') ||
    lower.includes('load failed') ||
    lower.includes('connectionerror') ||
    lower.includes('fetch failed') ||
    /timeout of \d+ms exceeded/.test(lower)
  );
}

export function isClientNetworkError(err) {
  if (err == null) return false;

  if (typeof err === 'string') {
    return isNetworkErrorMessage(err);
  }

  if (typeof err === 'object') {
    if (err.type === 'NETWORK_ERROR') return true;
    if (err.error?.type === 'NETWORK_ERROR') return true;
    if (err.status === 0 && err.success === false) return true;
    if (err.request && !err.response) return true;
    if (typeof err.code === 'string') {
      if (
        err.code === 'ERR_NETWORK' ||
        err.code === 'ECONNABORTED' ||
        err.code === 'ETIMEDOUT'
      ) {
        return true;
      }
    }
    const message = getMessage(err);
    if (message && isNetworkErrorMessage(message)) return true;
  }

  return false;
}
